import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuard } from './authGuardClass';

@Injectable({
  providedIn: 'root'
})
export class LogInService implements CanActivate {
  canActivate(
    router:ActivatedRouteSnapshot,
    state:RouterStateSnapshot
  ):Observable<boolean> | Promise<any>{
    return this.authGuard.checkLogIn()
    .then((authenticated:any)=>{
        if(authenticated && authenticated.userInfo == undefined){
            return true;
        }else if(authenticated && authenticated.userInfo != undefined){
            return authenticated;
        }
        else{
           this.router.navigate(['/'])
        }
    })
  }
  constructor(private authGuard:AuthGuard, private router:Router) { }
}
